import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Account } from '../model/account.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private _account!: BehaviorSubject<Account>;

  constructor(
    private http: HttpClient
  ) { }
  
  get account(): BehaviorSubject<Account> {
    if (!this._account) {
      this._account = new BehaviorSubject<Account>(new Account());
      this.requestAccount();
    }
    return this._account;
  }
  
  clearAccount() {
    this._account = new BehaviorSubject<Account>(new Account());
    sessionStorage.clear();
  }
  
  requestAccount() {
    this.http.get<Account>(environment.apiUrl + 'account').subscribe(account => {
      this._account.next(account)
    });
  }

}
